import { render, staticRenderFns } from "./ApiAccess.vue?vue&type=template&id=833ab9bc&scoped=true&"
import script from "./ApiAccess.vue?vue&type=script&lang=js&"
export * from "./ApiAccess.vue?vue&type=script&lang=js&"
import style0 from "./ApiAccess.vue?vue&type=style&index=0&id=833ab9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833ab9bc",
  null
  
)

export default component.exports